import React from 'react';
import { getErrorMessage, ErrorBoundary as ReactErrorBoundary, type FallbackProps } from 'react-error-boundary';
import { Alert, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Container } from './container';

const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  const { t } = useTranslation();
  const errorMessage = getErrorMessage(error);

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Alert severity="error" sx={{ mb: 2 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          {t('errors.somethingWentWrong')}
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {errorMessage}
        </Typography>
        <Button variant="outlined" onClick={resetErrorBoundary}>
          {t('errors.tryAgain')}
        </Button>
      </Alert>
    </Container>
  );
};

interface AppErrorBoundaryProps {
  children: React.ReactNode;
}

export const ErrorBoundary = ({ children }: AppErrorBoundaryProps) => (
  <ReactErrorBoundary
    fallbackRender={({ error, resetErrorBoundary }) => (
      <ErrorFallback error={error} resetErrorBoundary={resetErrorBoundary} />
    )}
  >
    {children}
  </ReactErrorBoundary>
);
